export const STORE_KEY = '__ACCOUNT_DETAILS__';
export const INITIAL_STATE = {
    accounts: [],
    loggedInAccountDetails: {
        account: undefined,
        permissions: [],
        isAdmin: false,
    },
    user: undefined,
};
